// src/pages/Home.jsx
function Home() {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h1>Welcome to the Home Page 🎉</h1>
      </div>
    );
  }
  
  export default Home;
  